export default "__VITE_ASSET__yoSr7Nv$CnO5MAToQ6URdQ__"